import React from 'react'
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react'
import { Node as ProseMirrorNode } from '@tiptap/pm/model'
import { Editor } from '@tiptap/core'
import { cn } from '@/lib/utils'
import { TabAttributes } from './tab-extension'

interface TabNodeViewProps {
  node: ProseMirrorNode
  editor: Editor
  getPos: () => number | undefined
  updateAttributes: (attributes: Record<string, any>) => void
  deleteNode: () => void
  selected: boolean
}

export function TabNodeView({
  node,
  editor: _editor,
  getPos: _getPos,
  updateAttributes: _updateAttributes,
  deleteNode: _deleteNode,
  selected,
}: TabNodeViewProps) {
  const attrs = node.attrs as TabAttributes

  return (
    <NodeViewWrapper
      className={cn(
        'tab-element mb-1 p-0',
        selected && 'ProseMirror-selectednode'
      )}
      data-type="Tab"
      data-title={attrs.title}
      data-icon={attrs.icon}
      data-icon-type={attrs.iconType}
      data-icon-category={attrs.iconCategory}
      data-icon-color={attrs.iconColor}
      data-show-icon={attrs.showIcon}
    >
      <div className={cn('tab-element')}>
        <NodeViewContent />
      </div>
    </NodeViewWrapper>
  )
} 